import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

import { coreDataSecurityAccessAuditReducers, coreDataSecurityAccessAuditWatchers } from './access-audit';
import {
	coreDataSecurityAccessComparisonReducers,
	coreDataSecurityAccessComparisonWatchers
} from './access-comparison';
import {
	coreDataSecurityAccessExplainerReducers,
	coreDataSecurityAccessExplainerWatchers
} from './access-explainer';
import {
	coreDataSecurityDataAccessPermissionSourcesReducers,
	coreDataSecurityDataAccessPermissionSourcesWatchers
} from './search/permission-sources';
import { coreDataSecurityDataAccessSearchReducers, coreDataSecurityDataAccessSearchWatchers } from './search';

export const coreDataSecurityDataAccessReducers = combineReducers({
	accessAudit: coreDataSecurityAccessAuditReducers,
	accessComparison: coreDataSecurityAccessComparisonReducers,
	accessExplainer: coreDataSecurityAccessExplainerReducers,
	permissionSources: coreDataSecurityDataAccessPermissionSourcesReducers,
	search: coreDataSecurityDataAccessSearchReducers
});

export const coreDataSecurityDataAccessWatchers = combineAllWatchers([
	coreDataSecurityAccessAuditWatchers,
	coreDataSecurityAccessComparisonWatchers,
	coreDataSecurityAccessExplainerWatchers,
	coreDataSecurityDataAccessPermissionSourcesWatchers,
	coreDataSecurityDataAccessSearchWatchers
]);
